var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.optionHoldings,"no-data-text":_vm.loadingOrNoDataText,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.dateOfIssue",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s((new Date(item.dateOfIssue)).toLocaleDateString('en-AU'))+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }